var MultiClamp = require('./MultiClamp');

module.exports = MultiClamp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/multi-clamp/index.js
// module id = ./node_modules/multi-clamp/index.js
// module chunks = main